// The signed-in user's display name and email, for stamping "created by" on
// records they raise (e.g. incidents).
//
// Reads straight from the MSAL instance rather than the useMsal() hook so it is
// safe to call when auth is disabled (local dev), where there is no
// MsalProvider in the tree. With auth off — or before sign-in — both fields are
// empty strings and the caller falls back gracefully.
//
// When a Super Admin is impersonating via "View as", identity instead follows
// the impersonated principal reported by GET /me, so the user-view pages ("My
// details/events") and "created by" stamping resolve to that person, not the
// admin's real account.
import { msalInstance, AUTH_ENABLED } from "./authConfig";
import { useMe } from "./MeContext";

export function useCurrentUser() {
  const { me } = useMe();
  if (me?.impersonating) {
    return { name: me.name || "", email: me.email || "" };
  }

  if (!AUTH_ENABLED) return { name: "", email: "" };

  // Once /me has linked them to a record, its email wins over the account's:
  // someone may sign in with a different address from the one on their record
  // (Personnel.login_email), and "created by"/"added by" snapshots are keyed on
  // the record's email (core/identity.py).
  const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  return {
    name: account?.name || account?.username || "",
    email: (me?.linked && me.email) || account?.username || "",
  };
}
